import { render, staticRenderFns } from "./ThemeButton.vue?vue&type=template&id=0db54564&scoped=true"
import script from "./ThemeButton.vue?vue&type=script&lang=js"
export * from "./ThemeButton.vue?vue&type=script&lang=js"
import style0 from "./ThemeButton.vue?vue&type=style&index=0&id=0db54564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db54564",
  null
  
)

export default component.exports